import React from "react";
import PropTypes from "prop-types";
import { fetchJson, post } from "../../lib/Fetching";
import ClientSuiteInput from "./ClientSuiteInput";
import SampleInformationInput from "./SampleInformationInput";
import ClientSpecificationInput from "./ClientSpecificationInput";
import { SingleDatePicker } from "react-dates";
import styled from "styled-components";
import Input from "../Input";
import { DefaultPaddedContainer } from "./Theme";

const Row = styled.div`
  padding-bottom: 10px;
`;

const Container = styled(DefaultPaddedContainer)`
  margin-bottom: 20px;
`;

class ProductsFilter extends React.Component {
  state = {
    view: "schedules",
    product_name: "",
    created_after: null,
    focused: null,
    client_suite_ids: [],
    sample_information_ids: [],
    client_specification_ids: [],
  };

  findProducts = () => {
    const { setProducts, setMode, company_id } = this.props;
    const {
      view,
      product_name,
      created_after,
      client_suite_ids,
      sample_information_ids,
      client_specification_ids,
    } = this.state;
    fetchJson("/products/products.json", {
      company_id,
      form: {
        include_schedules: view === "schedules",
        include_branches: view === "branches",
        include_product_defaults: view === "schedules",
        product_name,
        created_after,
        created_after: created_after ? created_after.format("YYYY-MM-DD") : null,
        client_suite_ids,
        sample_information_ids,
        client_specification_ids,
      },
    }).then((json) => {
      setProducts(json.products, view);
    });
  };

  setOptions = (field, options) => {
    this.setState({
      [field]: options.map((o) => o.value),
    });
  };

  changeView = (e) => this.setState({ view: e.target.value });

  render() {
    const { company_id } = this.props;
    const { product_name, view } = this.state;
    return (
      <Container>
        <Row className="row">
          <div className="col-md-4">
            <label>{I18n.t("product_name")}</label>
            <Input
              focus
              onPressEnter={this.findProducts}
              className="form-control"
              value={product_name}
              onChange={(e) => this.setState({ product_name: e.target.value })}
            />
          </div>
          <div className="col-md-4">
            <label>Created After</label>
            <br />
            <SingleDatePicker
              numberOfMonths={1}
              date={this.state.created_after}
              onDateChange={(date) => this.setState({ created_after: date })}
              focused={this.state.focused}
              onFocusChange={({ focused }) => this.setState({ focused })}
              id="created_after"
              showClearDate={true}
              isOutsideRange={() => false}
              hideKeyboardShortcutsPanel={true}
            />
          </div>
          <div className="col-md-4">
            <label>View</label>
            <br />
            <input
              id="schedules"
              type="radio"
              value="schedules"
              checked={view == "schedules"}
              onChange={this.changeView}
            />
            &nbsp;
            <label htmlFor="schedules">Test Schedules</label> &nbsp;&nbsp;&nbsp;
            <input
              id="branches"
              type="radio"
              value="branches"
              checked={view == "branches"}
              onChange={this.changeView}
            />
            &nbsp; <label htmlFor="branches">Branch Restrictions</label>
          </div>
        </Row>
        <Row className="row">
          <div className="col-md-4">
            <label>Client Suite</label>
            <ClientSuiteInput
              company_id={company_id}
              multiple={true}
              onChange={(options) => this.setOptions("client_suite_ids", options)}
            />
          </div>
          <div className="col-md-4">
            <label>Sample Information</label>
            <SampleInformationInput
              company_id={company_id}
              multiple={true}
              onChange={(options) => this.setOptions("sample_information_ids", options)}
            />
          </div>
          <div className="col-md-4">
            <label>Client Specification</label>
            <ClientSpecificationInput
              company_id={company_id}
              multiple={true}
              onChange={(options) => this.setOptions("client_specification_ids", options)}
            />
          </div>
        </Row>
        <div className="row">
          <div className="col-md-12">
            <button className="btn btn-default" onClick={this.findProducts}>
              Find Products
            </button>
          </div>
        </div>
      </Container>
    );
  }
}

export default ProductsFilter;

ProductsFilter.propTypes = {
  company_id: PropTypes.number,
  setProducts: PropTypes.func,
  setMode: PropTypes.func,
};
